(function () {
  function initVideos(root) {
    root.querySelectorAll('video').forEach(function (video) {
      video.controls = false;
      video.muted = true;
      video.playsInline = true;

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    });
  }

  function initStoryScroll(root) {
    var story = root.querySelector('[data-story-scroll]');
    if (!story || story.dataset.storyScrollInitialized === 'true') return;
    story.dataset.storyScrollInitialized = 'true';

    var image = story.querySelector('[data-story-image]');
    var panels = Array.from(story.querySelectorAll('[data-story-panel]'));
    if (!image || panels.length === 0) return;
    var mediaQuery = window.matchMedia('(min-width: 990px)');
    var activeIndex = -1;
    var ticking = false;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function activate(panel, index) {
      if (index === activeIndex) return;
      activeIndex = index;

      panels.forEach(function (item) {
        item.classList.toggle('is-active', item === panel);
      });

      var nextImage = panel.getAttribute('data-image');
      if (nextImage && image.getAttribute('src') !== nextImage) {
        image.style.opacity = '0';
        window.setTimeout(function () {
          image.setAttribute('src', nextImage);
          image.style.opacity = '1';
        }, 120);
      }
    }

    function updatePanelOpacity() {
      var viewportCenter = window.innerHeight / 2;
      var fadeDistance = window.innerHeight * 0.45;

      panels.forEach(function (panel) {
        var rect = panel.getBoundingClientRect();
        var panelCenter = rect.top + rect.height / 2;
        var distance = Math.abs(panelCenter - viewportCenter);
        var opacity = clamp(1 - distance / fadeDistance, 0, 1);
        var translate = clamp((panelCenter - viewportCenter) * -0.04, -15, 15);

        panel.style.opacity = opacity.toFixed(3);
        panel.style.transform = 'translateY(' + translate.toFixed(2) + 'px)';
      });
    }

    function updateStory() {
      ticking = false;

      if (!mediaQuery.matches) {
        panels.forEach(function (panel) {
          panel.style.opacity = '';
          panel.style.transform = '';
        });
        activate(panels[0], 0);
        return;
      }

      var rect = story.getBoundingClientRect();
      var progress = clamp((window.innerHeight / 2 - rect.top) / rect.height, 0, 0.999);
      var index = clamp(Math.floor(progress * panels.length), 0, panels.length - 1);

      activate(panels[index], index);
      updatePanelOpacity();
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateStory);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', requestUpdate);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(requestUpdate);
    }

    updateStory();
  }

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement;
    });
  }

  function initPlants(root) {
    var plantsSection = root.querySelector('[data-signature-plants]');
    if (!plantsSection) return;

    var readMoreButton = plantsSection.querySelector('[data-read-more]');
    var readLessButton = plantsSection.querySelector('[data-read-less]');
    var readMorePanel = plantsSection.querySelector('[data-read-more-panel]');
    var modal = plantsSection.querySelector('[data-plant-modal]');
    var dialog = plantsSection.querySelector('.main-about-plant-modal__dialog');
    var modalImage = plantsSection.querySelector('[data-plant-modal-image]');
    var modalTitle = plantsSection.querySelector('[data-plant-modal-title]');
    var modalDescription = plantsSection.querySelector('[data-plant-modal-description]');
    var closeButton = plantsSection.querySelector('[data-plant-close]');
    var lastFocusedElement = null;

    if (readMoreButton && readMorePanel) {
      readMoreButton.addEventListener('click', function () {
        readMorePanel.hidden = false;
        readMoreButton.hidden = true;
        readMoreButton.setAttribute('aria-expanded', 'true');
      });
    }

    if (readLessButton && readMorePanel && readMoreButton) {
      readLessButton.addEventListener('click', function () {
        readMorePanel.hidden = true;
        readMoreButton.hidden = false;
        readMoreButton.setAttribute('aria-expanded', 'false');
        readMoreButton.focus();
      });
    }

    if (!modal || !dialog || !modalImage || !modalTitle || !modalDescription || !closeButton) return;

    function closeModal() {
      if (modal.hidden) return;

      modal.hidden = true;
      document.removeEventListener('keydown', onKeydown);

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    function trapFocus(event) {
      if (event.key !== 'Tab') return;

      var focusable = getFocusableElements(dialog);
      if (focusable.length === 0) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        closeModal();
        return;
      }

      trapFocus(event);
    }

    function openModal(button) {
      var plant = button.closest('[data-plant]');
      var title = button.querySelector('span') ? button.querySelector('span').textContent.trim() : '';
      var description = plant && plant.querySelector('.main-about-plant__description')
        ? plant.querySelector('.main-about-plant__description').textContent.trim()
        : '';
      var image = button.getAttribute('data-plant-image');

      if (image) modalImage.setAttribute('src', image);
      modalImage.setAttribute('alt', title);
      modalTitle.textContent = title;
      modalDescription.textContent = description;

      lastFocusedElement = button;
      modal.hidden = false;
      document.addEventListener('keydown', onKeydown);
      dialog.focus();
    }

    plantsSection.querySelectorAll('[data-plant-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        openModal(button);
      });
    });

    closeButton.addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
  }

  function initUsAboutPage(root) {
    document.documentElement.classList.add('main-about-page-active');
    initVideos(root);
    initStoryScroll(root);
    initPlants(root);
  }

  function initAll() {
    document.querySelectorAll('[data-main-about-page]').forEach(initUsAboutPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
